import React from "react";
import { TruckBoxTrailer, TruckFlatBed, TruckTanker, TruckCurtainSider, TruckLightWeightCurtainSider, TruckBulkTrailer, TruckUndefinedType, TruckOnly } from "assets/icons";
import { VehicleTrailerType } from "store/vehicle-dashboard/vehicle-dashboard-model";
import useTranslation from "utils/hooks/useTranslation";
import { getSaleChannelConfig, getSaleChannelTruckColor, MANEUVER_TRUCK_COLOR } from "utils/saleChannel";

const SaleChannelColor = (truckDescription, TruckImg, color) => {
  return (
    <TruckImg
      color={color}
      alt={`Truck ${truckDescription}`}
      style={{
        transform: "rotateY(180deg)",
      }}
    ></TruckImg>
  );
};

const TruckImage = ({ saleChannelId, vehicleType, isManeuver = false }: { saleChannelId?: number | null; vehicleType?: number | null; isManeuver?: boolean }) => {
  const saleChannelConfig = getSaleChannelConfig(saleChannelId);
  const saleChannelDescription = useTranslation({ id: saleChannelConfig?.translationId ?? "fleet_channel_others" });
  const maneuverProcess = useTranslation({ id: "maneuver" });

  const vehicleIconMap: Partial<Record<number, React.ElementType>> = {
    [VehicleTrailerType.BOX_TRAILER]: TruckBoxTrailer,
    [VehicleTrailerType.CURTAINSIDER_DELTA_OPENING]: TruckCurtainSider,
    [VehicleTrailerType.FLATBED]: TruckFlatBed,
    [VehicleTrailerType.LIGHTWEIGHT_CURTAINSIDER]: TruckLightWeightCurtainSider,
    [VehicleTrailerType.BULK_TRAILER]: TruckBulkTrailer,
    [VehicleTrailerType.TANKER]: TruckTanker,
    [VehicleTrailerType.OTHER]: TruckUndefinedType,
  };

  const TruckComponent = isManeuver ? TruckOnly : (vehicleType != null && vehicleIconMap[vehicleType]) || TruckUndefinedType;
  const truckDescription = isManeuver ? maneuverProcess : saleChannelDescription;

  const color = isManeuver ? MANEUVER_TRUCK_COLOR : getSaleChannelTruckColor(saleChannelId);

  return <div>{SaleChannelColor(truckDescription, TruckComponent, color)}</div>;
};

export default TruckImage;
